import { render, staticRenderFns } from "./allSim.vue?vue&type=template&id=5f4820b8&scoped=true&"
import script from "./allSim.vue?vue&type=script&lang=js&"
export * from "./allSim.vue?vue&type=script&lang=js&"
import style0 from "./allSim.vue?vue&type=style&index=0&lang=css&"
import style1 from "./allSim.vue?vue&type=style&index=1&id=5f4820b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4820b8",
  null
  
)

export default component.exports